export enum VIEW_WIDGETS {
    basemapToggle = 'BasemapToggle',
    basemapGallery = 'Basemapgallery',
    compass = 'Compass',
    layerList = 'Layerlist'
}